function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import React from 'react';
import { WebRoutes } from '@/utils/constants';
import { FormattedMessage } from 'react-intl';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import styles from './DashboardButton.module.scss';
import Icon, { IconSizes } from './Icon';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import useHydrated from '@/hooks/useHydrated';
import { useShallow } from 'zustand/react/shallow';
export default function DashboardButton(props) {
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            isLoggedIn: state.isLoggedIn,
            accessToken: state.accessToken
        };
    })), isLoggedIn = _useAuthenticationStore.isLoggedIn, accessToken = _useAuthenticationStore.accessToken;
    var isHydrated = useHydrated(useAuthenticationStore);
    var showLoggedIn = !isHydrated || isLoggedIn || accessToken != null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.button,
        children: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            size: "sm",
            variant: showLoggedIn ? 'light' : 'inverse',
            rightSection: showLoggedIn ? /*#__PURE__*/ _jsx(Icon, {
                size: IconSizes.SM,
                icon: faArrowRight
            }) : null,
            component: Link,
            to: WebRoutes.DASHBOARD
        }, props), {
            children: showLoggedIn ? /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "hzSNj4",
                defaultMessage: "Dashboard"
            }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "OtVW5B",
                defaultMessage: "Add to Chat"
            })
        }))
    });
}
